export const TITLE_SIZE = 5;
export const SELECT_ALL_GROUPS = '1-0';
export const SELECT_ALL_UNITS = '0';

export const LAST_EVENTS_LENGTH_SIZE = 8;
